import { render, staticRenderFns } from "./DoKoCardSelectionHtml.vue?vue&type=template&id=1c858817&scoped=true&"
import script from "./DoKoCardSelectionHtml.vue?vue&type=script&lang=ts&"
export * from "./DoKoCardSelectionHtml.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoCardSelectionHtml.vue?vue&type=style&index=0&id=1c858817&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c858817",
  null
  
)

export default component.exports